export default __webpack_public_path__ + "static/media/rocket_anim_145.98aa4d56.png";